import React, { useState } from 'react';
import { RequiredDialogInput, DialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import { useCommonConfigFunctions } from '../../../hooks/useCommonConfigFunctions';

function SiteEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {

    const [fieldErrors, setFieldErrors] = useState({});

    const { createFunction, updateFunction, deleteFunction } = useCommonConfigFunctions("sites", "site");

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }

    const createOrUpdate = (object) => {
        return object.id ? updateFunction(object) : createFunction(object);
    }

    return (
        <CommonConfigDialog title={"Site - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={createOrUpdate} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} canDelete={true} deleteFunction={deleteFunction}>
            <RequiredDialogInput controlId="formSiteName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <RequiredDialogInput controlId="formSiteCode" title="Site Code" placeholder="Site Code" name="siteCode" value={dialogData.siteCode} error={fieldErrors.siteCode} onChange={onChange} />
            <DialogInput controlId="formSiteADGroupName" title="AD Group Name" placeholder="AD Group Name" name="adGroupName" value={dialogData.adGroupName} error={fieldErrors.adGroupName} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default SiteEditDialog;